"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoderVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
class DecoderVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitTypeFieldsBefore(context) {
        super.triggerTypeFieldsBefore(context);
        const type = context.type;
        this.write(`func Decode${type.name.value}Nullable(decoder *msgpack.Decoder) (*${type.name.value}, error) {
      if isNil, err := decoder.IsNextNil(); isNil || err != nil {
        return nil, err
      }
    decoded, err := Decode${type.name.value}(decoder)
    return &decoded, err
  }

  func Decode${type.name.value}(decoder *msgpack.Decoder) (${context.type.name.value}, error) {
    var o ${context.type.name.value}
    err := o.Decode(decoder)
    return o, err
  }

  func (o *${type.name.value}) Decode(decoder *msgpack.Decoder) error {
    numFields, err := decoder.ReadMapSize()
    if err != nil {
      return err
    }

    for numFields > 0 {
      numFields--;
      field, err := decoder.ReadString()
      if err != nil {
        return err
      }
      switch field {\n`);
    }
    visitTypeField(context) {
        const field = context.field;
        this.write(`case "${field.name.value}":\n`);
        this.write(helpers_1.read(false, `o.${helpers_1.fieldName(field.name.value)}`, true, "", field.type, false, helpers_1.isReference(field.annotations)));
        super.triggerTypeField(context);
    }
    visitTypeFieldsAfter(context) {
        if (context.fields.length > 0) {
            this.write(`default:
        err = decoder.Skip()
      }\n`);
        }
        this.write(`if err != nil {
      return err
    }
  }\n`);
        this.write(`
    return nil
  }\n\n`);
        super.triggerTypeFieldsAfter(context);
    }
}
exports.DecoderVisitor = DecoderVisitor;
//# sourceMappingURL=decoder_visitor.js.map